import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import CancelComplete from './cancel_complete';

describe('CancelComplete', () => {
  test('renders PurchaseComplete component', () => {
    render(<CancelComplete total_fee={12000} />);

    expect(screen.getByText("12,000円")).toBeInTheDocument();
    expect(screen.getByText('チケットをキャンセルしました。')).toBeInTheDocument();
  });
});
